/** True when every chart ref has persisted GridStack coordinates (faithful layout restore). */
export function dashboardChartRefsAllHaveGridCoords(refs) {
    return refs.length > 0 && refs.every((r) => typeof r.gridX === 'number' && typeof r.gridY === 'number');
}
/** Reading order for DOM and iteration: row, then column, then saved position. */
export function sortDashboardChartRefsForGrid(refs) {
    return [...refs].sort((a, b) => {
        const dy = (a.gridY ?? 0) - (b.gridY ?? 0);
        if (dy !== 0) {
            return dy;
        }
        const dx = (a.gridX ?? 0) - (b.gridX ?? 0);
        if (dx !== 0) {
            return dx;
        }
        return (a.position ?? 0) - (b.position ?? 0);
    });
}
